import { FormattedMessage } from 'react-intl';

import {
    ProgressIndicator,
    Step
} from '../../../../components/ProgressIndicator';

export const FundingProgressIndicator = () => (
    <ProgressIndicator data-testid="funding-progress-indicator">
        <Step
            status="complete"
            label="Application"
            message={
                <FormattedMessage
                    id="_.funding_progess_indicator.label.application"
                    defaultMessage="Application"
                />
            }
        />
        <Step
            status="complete"
            label="Provide documents"
            message={
                <FormattedMessage
                    id="_.funding_progess_indicator.label.provide_documents"
                    defaultMessage="Provide documents"
                />
            }
        />
        <Step
            status="active"
            label="Configure loan"
            message={
                <FormattedMessage
                    id="_.funding_progess_indicator.label.configure_loan"
                    defaultMessage="Configure loan"
                />
            }
        />
        <Step
            status="pending"
            label="Final checks"
            message={
                <FormattedMessage
                    id="_.funding_progess_indicator.label.final_checks"
                    defaultMessage="Final checks"
                />
            }
        />
        <Step
            status="pending"
            label="Withdraw funds"
            message={
                <FormattedMessage
                    id="_.funding_progess_indicator.label.withdraw_funds"
                    defaultMessage="Withdraw funds"
                />
            }
        />
    </ProgressIndicator>
);
